/* What the phone signed-in pages add to the app's own parts (docs/mockups/telify-web/phone-signed-in/*). Theme tokens only.
 Unlayered on purpose, like PhoneGuestHome.module.css: these rules sit beside the Mini App's own CSS modules, which are
 unlayered, and a layered rule always loses to an unlayered one. */

/* The messages screen opens over the page it was opened from. */
.messages {
  position: fixed;
  inset: 0;
  z-index: 90;
}
